import { mount } from "@vue/test-utils";
import FormValidator from "@/components/core/FormValidator";

describe("FormValidator Component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(FormValidator);
  });

  it("Renders del component FormValidator", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
